import { presentAppError } from '../services/errors/index';

/** Presentation-layer wrapper so UI never imports services directly. */
export function usePresentAppError() {
  return presentAppError;
}
